module.exports = __webpack_public_path__ + "static/media/offline.cc5baca7.jpg";